
import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'lib-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss'],
  standalone: true,
  imports: [CommonModule, MatIconModule]
})
export class ConfirmationModalComponent {
  headerText = signal('');
  bodyText = signal('');
  confirmButtonText = signal('');
  cancelButtonText = signal('');
  confirmationType = signal('');
  confirmButtonWarningMessage = signal('');

  public dialogRef = inject(MatDialogRef<ConfirmationModalComponent>);
  public data = inject(MAT_DIALOG_DATA);

  constructor() {
    if (this.data.headerText) this.headerText.set(this.data.headerText);
    if (this.data.bodyText) this.bodyText.set(this.data.bodyText);
    if (this.data.confirmButtonText) this.confirmButtonText.set(this.data.confirmButtonText);
    if (this.data.cancelButtonText) this.cancelButtonText.set(this.data.cancelButtonText);
    if (this.data.confirmationType) this.confirmationType.set(this.data.confirmationType);
    if (this.data.bodyWarningMessage) this.confirmButtonWarningMessage.set(this.data.bodyWarningMessage);
  }
  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
